import React from "react";
import { useTranslation } from "react-i18next";

const OVERALL_CONFIG = {
    operational: {
        bg: "bg-emerald-500",
        text: "text-white",
        label: "statusPage.allOperational",
    },
    degraded: {
        bg: "bg-amber-500",
        text: "text-white",
        label: "statusPage.someDegraded",
    },
    outage: {
        bg: "bg-red-500",
        text: "text-white",
        label: "statusPage.majorOutage",
    },
};

function StatusHeader({ overall, loading, error, lastRefresh }) {
    const { t } = useTranslation();
    const config = OVERALL_CONFIG[overall] || OVERALL_CONFIG.operational;

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-3">
                <h1 className="text-2xl font-bold text-gray-900">AgentUI</h1>
                <span className="text-sm text-gray-400">{t("statusPage.title")}</span>
            </div>
            <div className={`${config.bg} rounded-xl p-5 ${config.text}`}>
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        {loading ? (
                            <div className="w-3 h-3 rounded-full bg-white/50 animate-pulse" />
                        ) : (
                            <div className="w-3 h-3 rounded-full bg-white" />
                        )}
                        <span className="font-semibold text-lg">{t(config.label)}</span>
                    </div>
                    {lastRefresh && (
                        <span className="text-xs opacity-75">
                            {t("statusPage.lastChecked")}: {lastRefresh.toLocaleTimeString()}
                        </span>
                    )}
                </div>
                {error && (
                    <p className="mt-2 text-sm opacity-75">{error}</p>
                )}
            </div>
        </div>
    );
}

export default StatusHeader;
